<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title> Deshacer lotes </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span> Lotes a deshacer {{ lotes.length }} </span>
            </v-col>
            <v-col cols="12">
              <v-simple-table height="400px">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">ID lote</th>
                      <th class="text-left">Fecha de creación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in lotes" :key="index">
                      <td>{{ item.loteId }}</td>
                      <td>{{ dateFormat(item.createdAt) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="12" xl="6" lg="6" md="6">
              <v-btn color="gray" dark @click="show = false" block>
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="12" xl="6" lg="6" md="6">
              <v-btn color="primary" @click="apply" block> Aplicar </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from "dayjs";
export default {
  data: () => ({

  }),
  props: {
    value: Boolean,
    lotes: Array,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    dateFormat(value) {
      if (value) {
        const date = `${dayjs(value).format("DD-MM-YYYY - HH:mm")} hrs`;
        return date ? date : "-";
      } else {
        return "-";
      }
    },
    apply() {
      this.$emit("confirm");
    },
  },
};
</script>
